import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	every: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.read-only-view-with-actions.every',
		defaultMessage: 'Every',
		description: 'Label to recurring holiday',
	},
	yearly: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.read-only-view-with-actions.yearly',
		defaultMessage: 'Annually',
		description: 'Label to yearly recurring holiday',
	},
	never: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.holiday.read-only-view-with-actions.never',
		defaultMessage: 'One Time',
		description: 'Label to non recurring holiday',
	},
});
